import { create } from 'zustand';
import * as Enums from '@playbook-technologies/common-enums';

export const SORT_KEYS = {
  NAME: { name: 'Name', value: 'name' },
  PUBLISHED_AT: { name: 'Launch date', value: 'publishedAt' },
  CREATED_AT: { name: 'Created at', value: 'createdAt' },
};

export const INFLUENCER_VISIBILITY = [
  { name: 'All', value: null },
  { name: 'Premium', value: 'premium' },
  { name: 'Limited', value: 'limited' },
  { name: 'PPC', value: 'exclusive' },
];

export const INFLUENCER_MODES = [
  { name: 'All', value: null },
  Enums.Influencer.Mode.Onboarding,
  Enums.Influencer.Mode.Live,
  Enums.Influencer.Mode.RunOff,
  Enums.Influencer.Mode.Deactivated,
];

export const INFLUENCER_TIERS = [
  { name: 'All', value: 999 }, // TODO: need to come up with something better, null is already assigned to None
  Enums.Influencer.Tier.First,
  Enums.Influencer.Tier.Second,
  Enums.Influencer.Tier.Thrid,
  Enums.Influencer.Tier.Fourth,
  Enums.Influencer.Tier.Fifth,
  Enums.Influencer.Tier.Sixth,
  Enums.Influencer.Tier.None,
];

interface InfluencerListState {
  filters: {
    mode: number | null;
    sortBy: string;
    tier: number | null;
    visibility: string | null;
  };
  setFilter<T extends keyof InfluencerListState['filters']>(
    key: keyof InfluencerListState['filters'],
    value: InfluencerListState['filters'][T],
  ): void;
}

export const useInfluencerListStore = create<InfluencerListState>((set) => ({
  filters: {
    mode: null,
    sortBy: SORT_KEYS.NAME.value,
    tier: INFLUENCER_TIERS[0].value,
    visibility: null,
  },
  setFilter(key, value) {
    set((state) => ({
      filters: {
        ...state.filters,
        [key]: value,
      },
    }));
  },
}));
